import React, { useState, useEffect } from "react";
import { Drawer, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useGetSettingByKeyQuery, useUpsertSettingMutation } from "../../../../reducers/settingsApi";
import { toast } from "react-toastify";

const AlertConditionDrawer = ({ open, onClose, onUpdate }) => {
    const settingKey = "app.alertip";
    const { data: settingRes } = useGetSettingByKeyQuery(settingKey);
    const [upsertSetting, { isLoading: isSaving }] = useUpsertSettingMutation();

    const [alertSettings, setAlertSettings] = useState({
        pageViews: 20,
        visits: 2,
        checkoutVisits: 4
    });

    useEffect(() => {
        if (settingRes?.data?.value) {
            setAlertSettings(settingRes.data.value);
        }
    }, [settingRes]);

    const handleUpdate = (field, delta) => {
        setAlertSettings(prev => ({
            ...prev,
            [field]: Math.max(0, (prev[field] || 0) + delta)
        }));
    };

    const handleSave = async () => {
        try {
            const payload = {
                key: settingKey,
                value: alertSettings,
                description: "Alert conditions for IP traffic",
                category: "app",
                isPublic: true
            };
            await upsertSetting(payload).unwrap();
            toast.success("Alert conditions saved successfully");
            if (onUpdate) onUpdate();
        } catch (error) {
            console.error("Failed to save alert conditions:", error);
            toast.error("Failed to save alert conditions");
        }
    };

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            sx={{
                "& .MuiDrawer-paper": {
                    width: "450px",
                    top: "0px !important",
                    height: "100%",
                    p: 0,
                    backgroundColor: "#fafafa"
                }
            }}
        >
            <Box sx={{ p: 0 }}>
                <Box className="d-flex justify-content-between align-items-center px-3 py-3 bg-white" style={{ borderBottom: "1px solid #EEEEEE" }}>
                    <Typography className="sofiaBold" style={{ fontSize: "18px", color: "#1D1D1B" }}>
                        Alert conditions
                    </Typography>
                    <IconButton onClick={onClose} size="small" sx={{ backgroundColor: "#F5F5F5" }}>
                        <CloseIcon sx={{ fontSize: "18px" }} />
                    </IconButton>
                </Box>

                <Box sx={{ p: 2 }}>
                    <Box className="bg-white" style={{ borderRadius: "10px", border: "1px solid #EEEEEE" }}>
                        <Box className="d-flex justify-content-between align-items-center py-3 px-3" style={{ borderBottom: "1px solid #EEEEEE" }}>
                            <Typography className="sofiaRegular" style={{ fontSize: "14px", color: "#666" }}>Settings</Typography>
                            <button
                                disabled={isSaving}
                                onClick={handleSave}
                                className="sofiaBold px-3 py-1 bg-white"
                                style={{ border: "1px solid #1D1D1B", borderRadius: "8px", fontSize: "13px", cursor: isSaving ? "not-allowed" : "pointer" }}
                            >
                                {isSaving ? "Saving..." : "Save"}
                            </button>
                        </Box>

                        {[
                            { label: "Page Views", val: alertSettings.pageViews, field: "pageViews" },
                            { label: "Visits (days)", val: alertSettings.visits, field: "visits" },
                            { label: "Checkout Visits", val: alertSettings.checkoutVisits, field: "checkoutVisits" }
                        ].map((item, idx) => (
                            <Box key={idx} className="d-flex justify-content-between align-items-center py-3 px-3" style={{ borderBottom: "1px solid #EEEEEE" }}>
                                <Typography className="sofiaBold" style={{ fontSize: "14px", color: "#1D1D1B" }}>{item.label}</Typography>
                                <Box className="d-flex align-items-center gap-3">
                                    <Box
                                        onClick={() => handleUpdate(item.field, -1)}
                                        className="d-flex justify-content-center align-items-center"
                                        style={{ border: "1px solid #BBBBBB", borderRadius: "4px", cursor: "pointer", width: "24px", height: "24px" }}
                                    >
                                        <RemoveIcon sx={{ fontSize: "16px", color: "#BBBBBB" }} />
                                    </Box>
                                    <Typography className="sofiaBold" style={{ fontSize: "14px", width: "20px", textAlign: "center" }}>{item.val}</Typography>
                                    <Box
                                        onClick={() => handleUpdate(item.field, 1)}
                                        className="d-flex justify-content-center align-items-center"
                                        style={{ border: "1px solid #BBBBBB", borderRadius: "4px", cursor: "pointer", width: "24px", height: "24px" }}
                                    >
                                        <AddIcon sx={{ fontSize: "16px", color: "#BBBBBB" }} />
                                    </Box>
                                </Box>
                            </Box>
                        ))}

                    </Box>
                </Box>
            </Box>
        </Drawer>
    );
};

export default AlertConditionDrawer;
